export default __webpack_public_path__ + "static/media/car.cce5ea9c.jpg";